<script setup>
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { usePolicy } from 'dashboard/composables/usePolicy';
import FeaturePaywall from 'dashboard/routes/dashboard/settings/components/FeaturePaywall.vue';

import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import WhatsappCall from './channels/WhatsappCall.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import Voice from './channels/Voice.vue';

const props = defineProps({
  channelName: {
    type: String,
    required: true,
  },
});

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  whatsapp_call: WhatsappCall,
  line: Line,
  telegram: Telegram,
  instagram: Instagram,
  tiktok: Tiktok,
  voice: Voice,
};

const VOICE_CHANNELS = ['voice', 'whatsapp_call'];

const { shouldShowPaywall } = usePolicy();
const router = useRouter();
const route = useRoute();

watch(
  () => props.channelName,
  name => {
    if (name === 'api') {
      router.replace({
        name: 'settings_inbox_new',
        params: { accountId: route.params.accountId },
      });
    }
  },
  { immediate: true }
);

const isVoiceChannelPaywall = computed(
  () =>
    VOICE_CHANNELS.includes(props.channelName) &&
    shouldShowPaywall(FEATURE_FLAGS.CHANNEL_VOICE)
);

const ChannelComponent = computed(() => {
  if (props.channelName === 'api') {
    return null;
  }
  return channelViewList[props.channelName];
});
</script>

<template>
  <FeaturePaywall v-if="isVoiceChannelPaywall" feature-prefix="CALLS_PAGE" />
  <component :is="ChannelComponent" v-else-if="ChannelComponent" />
</template>
